import { render, staticRenderFns } from "./Add_questions.vue?vue&type=template&id=013bbbb4&"
import script from "./Add_questions.vue?vue&type=script&lang=js&"
export * from "./Add_questions.vue?vue&type=script&lang=js&"
import style0 from "./Add_questions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports